import React from 'react';
import AdminNav from '../../components/admin/AdminNav';
import InviteForm from '../../components/admin/InviteForm';
import { ScrollView } from '../../components/ui';
import AdminLayout from '../../layouts/AdminLayout';

const AdminIndex = () => (
  <AdminLayout>
    <AdminNav />
    <ScrollView>
      <InviteForm />
    </ScrollView>
  </AdminLayout>
);

export default AdminIndex;
